import { Link as MuiLink, Typography } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { KNOWN_ACTIONS } from 'index';

function SeeAlso({ without, ...rest }) {
  return (
    <section {...rest}>
      <Typography variant="h6" component="h2">
        See also
      </Typography>
      <ul>
        {KNOWN_ACTIONS.map((action) =>
          without !== action ? (
            <li key={action}>
              <MuiLink to={`/how-to-${action}-an-image-online`} component={Link}>
                How to {action} an image
              </MuiLink>
            </li>
          ) : null
        )}
      </ul>
    </section>
  );
}

export default SeeAlso;
